// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root___4j8Y","type":"styles_type__1OVY_","choices":"styles_choices__2Jw1t"};